import { BrandKey } from '../../__generated__/queries-web';

export const ALLOWED_MEDIA_PROGRAMS_PROVIDERS = [
  BrandKey.TEL,
  BrandKey.TLS,
  BrandKey.TGC,
  BrandKey.TESTBRAND,
];
export const ARTICLE_ENHANCEMENT_MAIN_TITLE = "Enrichir l'article";
